import { useQuery } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import type { File } from '@/api/types/backend-dto-types';
import useGetFetchConfig from '@/api/useGetFetchConfig';

export const useGetFiles = (matterId: string) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<File[], Error>(
    [QueryEntity.Files, { matterId }],
    async () => {
      const response = await fetch(`${APIBaseChronos}/api/matter/${matterId}/files`, fetchConfigGET);
      if (!response.ok) {
        console.error('Failed to fetch files', response);
        return [];
      }
      return await response.json();
    },
    { refetchOnWindowFocus: false, enabled: !!matterId },
  );
};
